import * as React from 'react';
import { connect } from 'react-redux';
import { RootState } from '@src/reducers';
import { IAlertState } from '@src/reducers/AlertReducer';
import { AlertActions } from '@src/actions/AlertActions';
import Alert from '@src/components/alert/Alert';

interface IReduxState {
    isVisible: boolean;
    msg: string;
}

interface IReduxActions {
    onClose: () => void;
}

type IAllProps = IReduxState & IReduxActions;

class ConnectedAlert extends React.Component<IAllProps, null> {
    render() {
        const { msg, onClose, isVisible } = this.props;

        if (!isVisible) {
            return null;
        }

        return (
            <div className="ConnectedAlert-wrap">
                <Alert body={msg} onClose={onClose} />
            </div>
        );
    }
}

const mapStateToProps = (state: RootState): IReduxState => {
    const alertState: IAlertState = state.alertState;
    return {
        isVisible: alertState.isVisible,
        msg: alertState.msg,
    };
};

const mapDispatchToProps = (dispatch: any): IReduxActions => {
    return {
        onClose: () => dispatch(AlertActions.hide()),
    };
};

export default connect<IReduxState, IReduxActions, null>(
    mapStateToProps,
    mapDispatchToProps,
)(ConnectedAlert);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/connected-alert/ConnectedAlert.tsx